export default __webpack_public_path__ + "3d915a0a67db8be5f306432eae2b421e.png";